<nscp-onboarding-wizard-trigger />

<router-outlet></router-outlet>
